import { useEffect, useState } from 'react';
/**
 * Tracks the window's inner width/height, updating on resize. Local,
 * dependency-free replacement for `usehooks-ts`'s `useWindowSize` so the
 * payment popup does not pull that package in (BENG-4169).
 *
 * Mirrors the previous behavior: size is 0×0 on the first (pre-mount) render
 * and gets the real dimensions once the mount effect runs — consumers rely on
 * `width/height > 0` to know the DOM is ready.
 */
export const useWindowSize = () => {
    const [size, setSize] = useState({ height: 0, width: 0 });
    useEffect(() => {
        const update = () => setSize({ height: window.innerHeight, width: window.innerWidth });
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);
    return size;
};
